/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import React from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { FaLinkedin } from 'react-icons/fa';
import { SiMalt } from 'react-icons/si';

import EmailIcon from '@mui/icons-material/Email';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/photoPurple.png'; // with import
import Divider from '../divider/Divider';
import CircularProgressBar from '../progressbar/CircularProgressBar';
import LinearProgressBar from '../progressbar/LinearProgressBar';
import BulletText from '../text/BulletText';
import TranslatedText from '../text/TranslatedText';
import './Presentation.css';
import PresentationLine from './PresentationLine';
import FranceFlag from '../../assets/flag/fr-suqare.svg';
import EnglishFlag from '../../assets/flag/gb-square.svg';
import myInfo from '../../config/myInfo';
import color from '../../config/color';

function Presentation() {
  const navigate = useNavigate();

  const handleAvatarClick = React.useCallback(() => {
    navigate('/');
  }, [navigate]);

  const RenderPresentationHeader = React.useCallback(() => (
    <div className="presentation-header">
      <button
        type="button"
        onClick={handleAvatarClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <img
          className="face"
          src={logo}
          alt="Avatar"
        />
      </button>
      <div className="presentation-txt-linkedin">
        <h5 className="name-txt">
          Jérôme Jouanny
        </h5>
        <a
          target="_blank"
          className="icon-button-linkedin"
          rel="noopener noreferrer"
          onMouseEnter={(a) => a.currentTarget.firstChild.style.color = '#0077b5'}
          onMouseLeave={(a) => a.currentTarget.firstChild.style.color = '#5c5c70'}
          href={myInfo.linkedinUrl}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <FaLinkedin size={20} />
        </a>
      </div>

      <div className="job-txt">
        <TranslatedText txt="work" />
      </div>

      <div className="job-txt">
        <TranslatedText txt="workDelivery" />
      </div>

    </div>
  ), [handleAvatarClick]);
  const RenderPresentationDesc = React.useCallback(() => (
    <div className="presentation-desc">
      <PresentationLine name="residence" value="france" />
      <PresentationLine name="city" value="paris" />
      <PresentationLine name="age" value="30" />
      <PresentationLine name="carlicense" value="B" />
    </div>
  ), []);

  const RenderPresentationLang = React.useCallback(() => (
    <div className="presentation-lang">
      <CircularProgressBar
        percentage={100}
        content={<img src={FranceFlag} alt="France" />}
        name="french"
      />
      <CircularProgressBar
        percentage={60}
        name="english"
        content={<img src={EnglishFlag} alt="English" />}
      />
    </div>
  ), []);

  const RenderPresentationSkill = React.useCallback(() => (
    <div className="presentation-skill">
      <LinearProgressBar percentage={80} name="React Native" label="expérimenté" />
      <LinearProgressBar percentage={80} name="React JS" label="expérimenté" />
      <LinearProgressBar percentage={80} name="JavaScript" label="expérimenté" />
      <LinearProgressBar percentage={80} name="TypeScript" label="expérimenté" />
      <LinearProgressBar percentage={80} name="Next JS" label="expérimenté" />
      <LinearProgressBar percentage={60} name="Redux" label="confirmé" />
      <LinearProgressBar percentage={80} name="Git" label="expérimenté" />
      <LinearProgressBar percentage={60} name="DevOps" label="confirmé" />
      <LinearProgressBar percentage={40} name="Vue JS" label="dérouillard" />
      <LinearProgressBar percentage={60} name="Python" label="confirmé" />
      <LinearProgressBar percentage={40} name="CMS" label="dérouillard" />
    </div>
  ), []);

  const RenderPresentationSoftware = React.useCallback(() => (
    <div className="presentation-software">
      <BulletText skills={['Canva, Figma']} />
      <BulletText skills={['Xcode, Android-Studio']} />
      <BulletText skills={['GitLab, GitHub']} />
      <BulletText skills={['CI/CD, Bitrise']} />
      <BulletText skills={['AWS, Azure']} />
      <BulletText skills={['DDD, Clean Archi']} />
      <BulletText skills={['Stripe, MUi']} />
    </div>
  ), []);

  return (
    <div className="presentation">
      <RenderPresentationHeader />
      <div className="presentation-content">
        <RenderPresentationDesc />
        <Divider marginVertical={10} />

        <Link
          to="/contact"
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <div className="presentation-contact" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <EmailIcon fontSize="small" />
            jouanny.jerome@gmail.com
          </div>
        </Link>
        <Divider marginVertical={10} />
        <RenderPresentationSkill />
        <Divider marginVertical={20} />
        <RenderPresentationLang />
        <Divider marginVertical={20} />

        <RenderPresentationSoftware />

        <div className="presentation-footer">
          <a
            href={myInfo.malt}
            target="_blank"
            className="icon-button-cv"
            onMouseEnter={(a) => a.currentTarget.firstChild.style.color = color.secondaryColor}
            onMouseLeave={(a) => a.currentTarget.firstChild.style.color = '#5c5c70'}
            style={{ textDecoration: 'none', color: 'inherit' }}
            rel="noreferrer"
          >
            <SiMalt
              size={60}
              className="icon-button-cv"
            />
          </a>

        </div>
      </div>
    </div>
  );
}

export default Presentation;
